import { createContext } from "react";
const MenuRendererContext = createContext(
  null
);
export {
  MenuRendererContext
};
